import { useDark, useToggle } from "@vueuse/core";

export class DarkMode {
  isDark = useDark();
  toggleDark = useToggle(this.isDark);
}
